import type { RequestTraceName, RequestTraceOutcome, RequestTracePhase } from './types'

export const REQUEST_TRACE_EVENT = 'strata.request.trace'

// Core ranking calls a different endpoint per model version, so each version is its own trace
export const CORE_RANKING_TRACE_BY_MODEL = {
  v1: 'coreRankingV1',
  v2: 'coreRankingV2',
} as const satisfies Record<string, RequestTraceName>

/**
 * Where each traced call goes, sent on every event so a failure says which endpoint to look at.
 * Path only, never a host or query string, so ids in a URL stay out of New Relic. GraphQL calls
 * share one URL, so they carry `graphql:` plus their operation name instead. Core ranking has one
 * key per model version, since the version decides the path. The keys are the traced calls, so
 * add a call here to trace a new one.
 */
export const REQUEST_TRACE_ENDPOINTS = {
  plans: 'graphql:Plans',
  customUsagePlans: 'graphql:plans',
  suggestedAddresses: 'graphql:GetSuggestedAddresses',
  utility: 'graphql:Utilities',
  dsUsage: '/api/v1/ds/usage',
  efl: '/api/v1/ds/get-efl-data/featured-plans',
  historicalCostConscious: '/historical-price/cost-conscious',
  historicalPriorRate: '/historical-price/prior-rate',
  historicalPlanLevel: '/historical-price/plan-level-price',
  coreRankingV1: '/api/v1/ds/core-ranking',
  coreRankingV2: '/api/v1/ds/core-ranking-v2',
} as const

/** The data calls whose success and duration are charted: the keys of the endpoint map. */
export const REQUEST_TRACE_REQUESTS = Object.keys(REQUEST_TRACE_ENDPOINTS) as RequestTraceName[]

export const REQUEST_TRACE_OUTCOMES = {
  start: 'info',
  success: 'ok',
  error: 'failed',
  invalid: 'invalid',
} as const satisfies Record<RequestTracePhase, RequestTraceOutcome>
